import { defineMessages } from 'react-intl';

export default defineMessages({
  descriptionLabel: {
    id: 'FileFollowups.PaymentCard.QuotationSummary.descriptionLabel',
    defaultMessage: 'Description',
  },
  congratulation: {
    id: 'FileFollowups.PaymentCard.QuotationSummary.congratulation',
    defaultMessage: 'Congratulations!',
  },

  bonusDidactic: {
    id: 'FileFollowups.PaymentCard.QuotationSummary.bonusDidactic',
    defaultMessage: 'You have all requirements to get bonus',
  },
  learnMore: {
    id: 'FileFollowups.PaymentCard.QuotationSummary.learnMore',
    defaultMessage: 'Learn more',
  },
});
